export const css = {
    root: '_2lQhwaI6',
    legend: '_1D5FvkWJ IUInj-vj',
    ' _key': 'apic-theme/dojo/checkbox-group'
};
export default css;
